import GreyTable from '../../../../components/Tables/GreyTable'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const BillingQuality = ({ Muldata }) => {

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount ?? 0);

  const formatIndianRupee2 = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(amount ?? 0);

  const formatIndianRupee1 = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount ?? 0);

  const { AccountToPGroupListData } = useSelector((state) => state.PartyProfileSlice);
  const { DlvQualityData } = useSelector((state) => state.PartyProfileSlice);


  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );
  const { theme } = useTheme();
  const isdark = theme;


  const columns = [
    { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "ItemName", label: "QUALITY NAME", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Meter", label: "METER", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Taka", label: "TAKA", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Tp", label: "TP", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Rate", label: "AVG. RATE", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Amount", label: "AMOUNT", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "SGST", label: "SGST", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "CGST", label: "CGST", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Total", label: "TOTAL", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  if (DlvQualityData === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <>
      <div>
        <Row>
          <Col>
            <>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8,
                    padding: "14px",
                  }}
                >
                  <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px",fontWeight:"700" }}>
                    MERGING
                  </h2>
                </div>

                {DlvQualityData?.DlvQuality &&
                  DlvQualityData?.DlvQuality?.length > 0 ? (
                  <GreyTable
                    columns={columns}
                    data={DlvQualityData?.DlvQuality?.map((row, index) => ({
                      id: index,
                      ...row,
                      Meter: formatIndianRupee(row.Meter),
                      Taka: formatIndianRupee1(row.Taka),
                      Tp: formatIndianRupee1(row.Tp),
                      Rate: formatIndianRupee2(row.Rate),
                      Amount: formatIndianRupee1(row.Amount),
                      Total: formatIndianRupee(row.Total),
                      SGST: formatIndianRupee(row.SGST),
                      CGST: formatIndianRupee(row.CGST),
                    }))}
                    iscolourDark={iscolourDark}
                    iscolour={iscolour}
                  />
                ) : (
                  <p style={{ color: "red", fontWeight: "bold" }}>
                    Data Not Found
                  </p>
                )}
              </div>
            </>

            {Muldata?.map((el) => {
              return (
                <>

                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                      marginTop: "20px"
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour8,
                        padding: "14px",
                      }}
                    >
                      <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px",fontWeight:"700" }}>
                        {AccountToPGroupListData?.Data?.find(
                          (nel) => Number(el.group) === Number(nel.ProductionGroupMstID)
                        )?.ProductionGroupMstName || `Group ${el.group}`}
                      </h2>
                    </div>

                    {el.DlvQuality && el.DlvQuality?.length > 0 ? (
                      <GreyTable
                        columns={columns}
                        data={el?.DlvQuality?.map((row, index, arr) => ({
                          id: index,
                          ...row,
                          srNumber: (index + 1)
                            .toString()
                            .padStart(arr.length.toString().length, "0"),
                          Meter: formatIndianRupee(row.Meter),
                          Taka: formatIndianRupee1(row.Taka),
                          Tp: formatIndianRupee1(row.Tp),
                          Rate: formatIndianRupee2(row.Rate),
                          Amount: formatIndianRupee1(row.Amount),
                          Total: formatIndianRupee(row.Total),
                          SGST: formatIndianRupee(row.SGST),
                          CGST: formatIndianRupee(row.CGST),
                        }))}
                        iscolourDark={iscolourDark}
                        iscolour={iscolour}
                      />
                    ) : (
                      <p
                        style={{
                          color: "#ff0000",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Data Not Found
                      </p>
                    )}
                  </div>
                </>
              );
            })}
          </Col >
        </Row>
      </div>
    </>
  )
}


